import { capitalize } from 'lodash'
import { EditableActivity } from '@screens/Activities/types'

export type LogActivityActionTunnelDraft = {
  kind: string
  type: string
  description: string
  startedAt: string
  endedAt: string
}

export type LogActivityActionTunnelDraftUpdate = Pick<
  EditableActivity,
  'type' | 'description' | 'startedAt' | 'endedAt'
>

const getDraftDateValue = (
  draft: Record<string, unknown>,
  snakeCaseKey: string,
  camelCaseKey: string,
) => {
  if (typeof draft[snakeCaseKey] === 'string') {
    return draft[snakeCaseKey]
  }

  if (typeof draft[camelCaseKey] === 'string') {
    return draft[camelCaseKey]
  }

  return ''
}

export const getLogActivityActionTunnelDraft = (
  value: unknown,
): LogActivityActionTunnelDraft | null => {
  if (!value || typeof value !== 'object') {
    return null
  }

  const currentDraft = value as Record<string, unknown>
  const kind = typeof currentDraft.kind === 'string' ? currentDraft.kind : ''

  return {
    kind,
    type: capitalize(kind),
    description: typeof currentDraft.description === 'string' ? currentDraft.description : '',
    startedAt: getDraftDateValue(currentDraft, 'started_at', 'startedAt'),
    endedAt: getDraftDateValue(currentDraft, 'ended_at', 'endedAt'),
  }
}

export const getActivityFromActionTunnelDraft = (
  draft: LogActivityActionTunnelDraft,
): EditableActivity => ({
  id: undefined,
  type: draft.type,
  startedAt: draft.startedAt,
  endedAt: draft.endedAt,
  favorite: false,
  description: draft.description,
  statistics: {},
  externalSource: undefined,
})

export const replaceLogActivityActionTunnelDraft = (
  draft: unknown,
  update: LogActivityActionTunnelDraftUpdate,
) => {
  if (!draft || typeof draft !== 'object') {
    return draft
  }

  const currentDraft = draft as Record<string, unknown>

  return {
    ...currentDraft,
    kind: update.type.toLowerCase(),
    description: update.description,
    started_at: update.startedAt,
    ended_at: update.endedAt,
  }
}
